// 마스킹 컬럼 처리 함수
export const normalizeMaskingValue = (value: string, type: string) => {
  if (!value) return '';
  if (type === 'tel') {
    const newValue = value.replaceAll('-', '');
    return autoHyphen(newValue);
  }
  if (type === 'birth') {
    return decodeBirthValue(value);
  }
  return value;
};

const autoHyphen = (target: string) => {
  if (target.slice(0, 2) === '02') {
    return target.replace(/[^0-9]/g, '').replace(/^(\d{2})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
  const value = target.replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  return value;
};

const decodeBirthValue = (target: string) => {
  if (!target) return '';

  const cleanValue = target.replace(/[^0-9]/g, '');
  if (cleanValue.length !== 8) return target;

  return `${cleanValue.substring(0, 4)}-${cleanValue.substring(4, 6)}-${cleanValue.substring(6)}`;
};
